import { graphql, useStaticQuery } from "gatsby";

export const useBlogTopics = () => {
    const { topics } = useStaticQuery(graphql`
        query BlogTopicsQuery {
            topics: allContentfulBlogTopic(sort: { name: ASC }) {
                edges {
                    node {
                        name
                        slug
                        article {
                            type
                        }
                    }
                }
            }
        }
    `);

    return topics?.edges?.map(({ node }) => node);
};
